import { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MSALConfig } from './config/MSALConfig';
import { UQToastProvider } from '@dev/uniq-ui';
import Layout from './components/Layout.tsx';
import EmployeeConfigEditor from './components/EmployeeConfigEditor.tsx';
import FullscreenLoader from './components/FullscreenLoader';

const msalInstance = new PublicClientApplication(MSALConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <UQToastProvider>
        <Suspense fallback={<FullscreenLoader />}>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<EmployeeConfigEditor />} />
              </Routes>
            </Layout>
          </Router>
        </Suspense>
      </UQToastProvider>
    </MsalProvider>
  );
}

export default App;